<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Footer</h2>
    </header>

    <TemplateImageInput
      v-model="content.logo"
      :upload-url="uploadUrl"
      subfolder="footer"
      label="Footer logo"
      help-text="Appears in the page footer. Leave blank to use the campaign's default logo."
    />

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Tagline</label>
      <textarea
        v-model="content.tagline"
        rows="2"
        maxlength="500"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
      />
    </div>

    <div>
      <label class="mb-2 block text-sm font-medium text-gray-700">Connect links</label>
      <TemplateRepeatableList
        v-model="content.connect_links"
        :max-items="12"
        :new-item="newLink"
        item-noun="link"
      >
        <template #item="{ item }">
          <div class="grid grid-cols-2 gap-2">
            <input
              v-model="item.label"
              type="text"
              maxlength="120"
              placeholder="Label"
              class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
            >
            <input
              v-model="item.link"
              type="text"
              maxlength="500"
              placeholder="URL"
              class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
            >
          </div>
        </template>
      </TemplateRepeatableList>
    </div>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Copyright</label>
      <input
        v-model="content.copyright"
        type="text"
        maxlength="500"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
      >
    </div>
  </section>
</template>

<script>
import TemplateImageInput from '../TemplateImageInput.vue';
import TemplateRepeatableList from '../TemplateRepeatableList.vue';

export default {
  name: 'FooterSectionEditor',
  components: { TemplateImageInput, TemplateRepeatableList },
  props: {
    content: { type: Object, required: true },
    uploadUrl: { type: String, required: true },
  },
  methods: {
    newLink() {
      return { label: '', link: '' };
    },
  },
};
</script>
